import React from "react";
import { motion } from "framer-motion";
import "./Categories.css";
import flat from "../Images/flat.png";
import house from "../Images/house.png";
import hostel from "../Images/hostel.png";
import commercial from "../Images/commercial.png";

const categories = [
  { img: flat, title: "Flats", text: "Modern apartments" },
  { img: house, title: "Houses", text: "Spacious family homes" },
  { img: hostel, title: "PG/Hostel", text: "Shared living spaces" },
  { img: commercial, title: "Commercial", text: "Offices and retail" },
];

const Categories = () => {
  return (
    <section className="categories container">
      <h2 className="section-title">Explore Popular Categories</h2>

      <div className="category-list">
        {categories.map((item, i) => (
          <motion.div
            className="cat-item"
            key={i}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.45, delay: i * 0.08 }}
          >
            <div className="icon-box">
              <img src={item.img} alt={item.title} />
            </div>
            <h4>{item.title}</h4>
            <p>{item.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Categories;
